import Immutable from 'seamless-immutable';

export default {
  namespace: 'calligraphy',
  state: Immutable({
    calligraphyInfo: {}
  }),
  reducers: {
    update: (state, { data, field }) => {
      return state.merge({ [field]: data });
    }
  },
  actions: {
    updateCalligraphyInfo: data => ({
      type: 'calligraphy/update',
      field: 'calligraphyInfo',
      data
    })
  }
};